import OptionSelector from '../OptionSelector/OptionSelector';

import './OrderProductItem.scss';

const OrderProductItem = ({
  id,
  title,
  image,
  value = 0,
  onChange,
  multiplier,
  maxValue,
  itemLabels,
  imageStyles,
  allowNone = true,
  descriptionItems,
}) => (
  <div className="OrderProductItem">
    <div className="OrderProductItem__header">
      <div className="OrderProductItem__image-container">
        <img src={image} alt={title} className="OrderProductItem__image" style={imageStyles} />
      </div>
      <div className="OrderProductItem__title-container">
        <div className="OrderProductItem__title">{title}</div>
        {descriptionItems && (
          <ul className="OrderProductItem__title-container--description-items">
            {descriptionItems.map((item) => (
              <li key={item} className="OrderProductItem__title-container--description-items--item">{item}</li>
            ))}
          </ul>
        )}
      </div>
    </div>

    <div className="OrderProductItem__selector">
      <OptionSelector
        id={id}
        value={value}
        endValue={maxValue}
        multiplier={multiplier}
        itemLabels={itemLabels}
        allowNone={allowNone}
        onChange={onChange}
      />
    </div>
  </div>
);

export default OrderProductItem;
